<template>
  <v-data-table :headers="headers"
                :items="debts"
                item-key="nr"
                class="mt-4"
                hide-default-footer
                :items-per-page="-1"
                :mobile-breakpoint="0">
    <template #item.debtSummary.total="{ item }">
      {{ item.debtSummary.total | currency }}
    </template>
    <template #item.debtSummary.left="{ item }">
      {{ item.debtSummary.left | currency }}
    </template>
  </v-data-table>
</template>

<script>
  export default {
    props: ['debts'],
    computed: {
      headers () {
        return [
          { text: this.$t('debt'), value: 'nr' },
          { text: this.$t('creditor'), value: 'creditor.name' },
          { text: this.$t('sum'), value: 'debtSummary.total' },
          { text: this.$t('left'), value: 'debtSummary.left' }
        ]
      }
    }
  }
</script>
